import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import EmployerForm from "./pages/EmployerForm";
import CandidateForm from "./pages/CandidateForm";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import Admin from "./pages/Admin";
import useVisitorTracking from "./hooks/useVisitorTracking";
import ResumeChecker from "./pages/ResumeChecker";
import PostJob from "./pages/PostJob";
import ResumeTailor from "./pages/ResumeTailor";
import Jobs from "./pages/Jobs";

function AppRoutes() {
  useVisitorTracking();

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/post-job" element={<PostJob />} />
      <Route path="/resume-checker" element={<ResumeChecker />} />
      <Route path="/resume-tailor" element={<ResumeTailor />} />
      <Route path="/employers" element={<EmployerForm />} />
      <Route path="/candidates" element={<CandidateForm />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
